import { Alert, AlertTitle, Snackbar } from "@mui/material";
import { Transition } from "../../pages/app/utils/animation";
import { useAlerts } from "../../store/alerts/hooks";

export const SyncAlert = ({ regions, selectedTag }) => {
  const { showSyncAlert, closeSyncAlert } = useAlerts();

  return (
    <Snackbar
      open={showSyncAlert}
      onClose={() => closeSyncAlert()}
      autoHideDuration={5000}
      message="This Snackbar will be dismissed in 5 seconds."
      slots={{
        transition: Transition,
      }}
      sx={{
        "&.MuiSnackbar-root": {
          transform: "translate(-50%, -50%)",
          top: "50%",
          left: "50%",
        },
      }}
    >
      <Alert
        onClose={() => closeSyncAlert()}
        severity="info"
        variant="outlined"
        sx={{ bgcolor: "background.paper", boxShadow: 3 }}
      >
        <AlertTitle>Please select a single annotation for syncing.</AlertTitle>
        Selected an annotation that consists of{" "}
        {
          regions
            ?.map((item) => item.tag)
            .filter((item) => item === selectedTag).length
        }{" "}
        segments.
      </Alert>
    </Snackbar>
  );
};
